import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./GroupTitle.module.css";
import { useTranslation } from "@coworker/locales";
import { useMemo } from "react";
import { formatLocationName } from "../../helpers/formatLocationName";

type GroupTitleProps = {
  locationCode: string;
};

function GroupTitle({ locationCode }: GroupTitleProps) {
  const { t } = useTranslation();

  const title = useMemo(() => {
    const key = `locations.${locationCode}`;
    const translated = t(key);

    if (translated === key) {
      return formatLocationName(locationCode, t);
    }
    return translated;
  }, [locationCode, t]);

  return (
    <li className={styles["root"]}>
      <FixaText textStyle="Heading.XS">{title}</FixaText>
    </li>
  );
}

export default GroupTitle;
